module.exports = __webpack_public_path__ + "static/img/3883_phase_function_Paper_PointsHejduk_Prediction.24620be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3883_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cEuY
// module chunks = 0